var React = require('react');

function VideoPauseIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 40C0 17.9086 17.9086 0 40 0V0C62.0914 0 80 17.9086 80 40V40C80 62.0914 62.0914 80 40 80V80C17.9086 80 0 62.0914 0 40V40Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M34.6154 32H37.3846C37.7245 32 38 32.3256 38 32.7273V47.2727C38 47.6744 37.7245 48 37.3846 48H34.6154C34.2755 48 34 47.6744 34 47.2727V32.7273C34 32.3256 34.2755 32 34.6154 32ZM42.6154 32H45.3846C45.7245 32 46 32.3256 46 32.7273V47.2727C46 47.6744 45.7245 48 45.3846 48H42.6154C42.2755 48 42 47.6744 42 47.2727V32.7273C42 32.3256 42.2755 32 42.6154 32Z","fill":"#22202F","key":1})]);
}

VideoPauseIcon.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none"};

module.exports = VideoPauseIcon;

VideoPauseIcon.default = VideoPauseIcon;
